import type React from "react";
import {
  type OptionsList,
  SelectComboField,
  type SelectComboFieldProps,
} from "../../../components/Forms/SelectCombo/SelectCombo.tsx";
import { issueCategoriesEnum } from "../../../kubb";

type ManualIssueCategorySelectProps = Omit<SelectComboFieldProps, "options">;

export default function ManualIssueCategorySelect(
  props: ManualIssueCategorySelectProps,
): React.ReactElement {
  const options: OptionsList = [
    {
      label: "Not adopted",
      value: issueCategoriesEnum["MANUAL.NOT_ADOPTED"],
    },
  ];
  return <SelectComboField {...props} options={options} />;
}
